import { render, staticRenderFns } from "./printfeiyongbaoxiao.vue?vue&type=template&id=dc98c7ee&scoped=true&"
import script from "./printfeiyongbaoxiao.vue?vue&type=script&lang=js&"
export * from "./printfeiyongbaoxiao.vue?vue&type=script&lang=js&"
import style0 from "./printfeiyongbaoxiao.vue?vue&type=style&index=0&id=dc98c7ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc98c7ee",
  null
  
)

export default component.exports